'use client';

import type {
  ShipperCategory,
  ShipperData,
} from '@/_service/shipper-category.service';

export const getCategoryLabel = (category: ShipperCategory, locale: string) =>
  category.name?.[locale as keyof ShipperCategory['name']] ||
  category.name?.ru ||
  category.name?.en ||
  category.name?.uz ||
  '';

export const buildImageSrc = (src?: string) => {
  if (!src) return undefined;
  return src.startsWith('http') ? src : `${process.env.BASE_URL ?? ''}${src}`;
};

export type { ShipperCategory, ShipperData };
